var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-list" },
    [
      _c("div", { staticClass: "info-div" }, [
        _c("h1", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("__.Crud.usuario.list_vue_html.usuarios"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "info-panel" }, [
            _c("span", [_vm._v(_vm._s(_vm.total))]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("__.Crud.usuario.list_vue_html.usuarios"))),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("__.Crud.usuario.list_vue_html.cadastrados"))
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "grid-component",
        {
          ref: "gridcomponent",
          attrs: {
            actionName: "usuarios",
            columns: _vm.gridColumns,
            data: _vm.gridData,
            "page-index": _vm.pageIndex,
            "page-size": _vm.pageSize,
            startFilterKey: _vm.startFilterKey,
            tituloPagina: "Usuários",
            total: _vm.total,
          },
          on: {
            "change-filter-key": _vm.onChangeFilterKey,
            "change-page": _vm.onChangePage,
            "change-sort": _vm.onChangeSort,
            "create-item": _vm.onCreateItem,
            "edit-item": _vm.onEditItem,
            "gerar-impressao": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 2
            },
            "gerar-pdf": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 1
            },
            "gerar-xls": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 0
            },
            "remove-item": _vm.onRemoveItem,
          },
        },
        [
          _vm.VALIDAR_PERMISSAO_USUARIO("usuarios", "update")
            ? _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("div", { staticClass: "filtro-lista" }, [
                  _c(
                    "button",
                    {
                      staticClass: "filtro-avancado-button",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.isHidden = !_vm.isHidden
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("__.Crud.filtroAvancado")) +
                          "\n                    "
                      ),
                      _c("i", { staticClass: "fa fa-caret-down" }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isHidden,
                          expression: "isHidden",
                        },
                      ],
                      staticClass: "drop-lista",
                    },
                    [
                      _c(
                        "form",
                        {
                          attrs: { novalidate: "novalidate" },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.getFormValues($event)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "radio-group",
                              staticStyle: { "margin-bottom": "15px" },
                            },
                            [
                              _c("div", { staticStyle: { display: "table" } }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "control-label",
                                        attrs: { for: "situacaoUsuario" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.$t(
                                                "__.Crud.usuario.list_vue_html.situacaoUsuario"
                                              )
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("combo-component", {
                                      staticStyle: { background: "white" },
                                      attrs: {
                                        id: "situacaoUsuario",
                                        name: "situacaoUsuario",
                                        data: _vm.situacaoUsuarioOptions,
                                      },
                                      model: {
                                        value: _vm.situacaoUsuarioFiltro,
                                        callback: function ($$v) {
                                          _vm.situacaoUsuarioFiltro = $$v
                                        },
                                        expression: "situacaoUsuarioFiltro",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "control-label",
                                        attrs: { for: "grupoUsuario" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.$t(
                                                "__.Crud.usuario.list_vue_html.grupoUsuario"
                                              )
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("combo-component", {
                                      staticStyle: { background: "white" },
                                      attrs: {
                                        id: "grupoUsuario",
                                        name: "grupoUsuario",
                                        data: _vm.grupoUsuarioOptions,
                                      },
                                      model: {
                                        value: _vm.grupoUsuarioFiltro,
                                        callback: function ($$v) {
                                          _vm.grupoUsuarioFiltro = $$v
                                        },
                                        expression: "grupoUsuarioFiltro",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "button",
                              {
                                staticClass: "botao-filtrar",
                                attrs: { type: "submit" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("__.Crud.filtrar")) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }